import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FormSelect from "./FormSelect";

import {DISPLAYS} from '../../utilities/constants';
import {TEXT} from '../../utilities/strings';

/**
 * Component to render the Type Select dropdown
 *
 * @example
 * <TypeSelect
 *   label={TEXT.display_type + ':'}
 *   formId="displayType"
 *   formName={this.props.formName}
 *   value={this.state.displayType}
 *   onChange={value =&gt; this.setState({displayType: value})}
 *  />
 */
export default class TypeSelect extends Component {

  static propTypes = {
    value: PropTypes.string,
    formId: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  render() {
    return (
      <FormSelect
        value={this.props.value}
        label={this.props.label}
        formId={this.props.formId}
        formName={this.props.formName}
        onChange={this.props.onChange}>

        <option value={DISPLAYS.CHART}>{TEXT.display_chart}</option>
        <option value={DISPLAYS.TABLE}>{TEXT.display_table}</option>

      </FormSelect>
    );
  }
}
